import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogPageComponent } from './blog-page/blog-page.component';
import { RouterModule, Routes } from '@angular/router';
import { BlogRedirectComponent } from './blog-components/blog-redirect/blog-redirect.component';
import { CmsComponentsModule } from '../../cms-components/cms-components.module';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { BlogBreadcrumbResolver } from '@lobos/library';

const routes: Routes = [
  {
    path: 'post/:id',
    data: {
      breadcrumbs: BlogBreadcrumbResolver,
    },
    component: BlogPageComponent,
  },
  {
    path: '**',
    component: BlogRedirectComponent,
  },
];

@NgModule({
  declarations: [BlogPageComponent, BlogRedirectComponent],
  imports: [CommonModule, RouterModule.forChild(routes), CmsComponentsModule, TranslocoLocaleModule],
})
export class BlogModule {}
